var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledArrowDownNoStem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 7.111C6.78287 7.111 6.56668 7.03766 6.39048 6.89003L0.67609 2.12779C0.272273 1.79157 0.217034 1.19058 0.554183 0.786737C0.89038 0.382899 1.49039 0.328609 1.89516 0.664824L7.01049 4.92799L12.1173 0.818168C12.5268 0.48862 13.1268 0.553387 13.4563 0.96294C13.7859 1.37249 13.7211 1.97158 13.3116 2.30208L7.59717 6.90051C7.42288 7.04052 7.21145 7.111 7.00002 7.111Z",
    fill: "#393D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledArrowDownNoStem);
export default __webpack_public_path__ + "static/media/icon-filled-arrow-down-no-stem.926541d5b61ade84b4c0f082b2d332b7.svg";
export { ForwardRef as ReactComponent };